import { createContext, useCallback, useReducer } from "react";
import RidesReducer from "./RideReducer";
import { getRides } from "./apiCalls"; // change to your actual path

const INITIAL_STATE = {
    rides: [],
    isFetching: false,
    error: false,
    hasFetched: false,
};

export const RidesContext = createContext(INITIAL_STATE);

export const RidesContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(
        RidesReducer,
        INITIAL_STATE
    );

    const fetchRides = useCallback(
        async (toast, forceRefresh = false) => {
            // Already fetched → don't make another API call
            if (state.hasFetched && !forceRefresh) {
                return;
            }

            await getRides(dispatch, toast);
        },
        [state.hasFetched]
    );

    return (
        <RidesContext.Provider
            value={{
                rides: state.rides,
                isFetching: state.isFetching,
                error: state.error,
                hasFetched: state.hasFetched,
                dispatch,
                fetchRides,
            }}
        >
            {children}
        </RidesContext.Provider>
    );
};